import React, { useState } from "react";

import { isEmpty } from "lodash/fp";

import { FeedbackSnackbarHeader } from "@app/analytics/components/reports/ReportFeedbackSnackbar";
import NegativeFeedbackFormContent from "@app/analytics/TopicReport/components/NegativeFeedbackFormContent";
import type { TopicReportFeedbackDetails } from "@app/analytics/TopicReport/types";

import Button from "@rui/Button";
import { Row } from "@rui/Stack";

import { ContentWrapper } from "./styles";

const NegativeFeedbackForm = ({
  isSubmitting,
  onChange,
  onClose,
  onSubmit,
  values,
}: {
  isSubmitting: boolean;
  onChange: (values: Partial<TopicReportFeedbackDetails>) => void;
  onClose: () => void;
  onSubmit: () => void;
  values: TopicReportFeedbackDetails;
}) => {
  const [formError, setFormError] = useState<string | null>(null);

  const selectedReportAction = values.action;

  const handleClickSubmit = () => {
    if (isEmpty(values.reasons)) {
      return setFormError("Please select at least 1 reason");
    }

    onSubmit();
  };

  return (
    <ContentWrapper spacing={2}>
      <FeedbackSnackbarHeader
        title="Give feedback"
        subtitle="What don't you like about this Readout?"
        icon="pending"
        onClose={onClose}
      />
      <NegativeFeedbackFormContent
        errorMessage={formError}
        values={values}
        onChange={onChange}
        onChangeErrorMessage={setFormError}
        includePostSubmitAction
      />
      <Row variant="right">
        <Button onClick={handleClickSubmit} loading={isSubmitting}>
          Submit feedback{selectedReportAction === "remove" ? " & remove" : ""}
        </Button>
      </Row>
    </ContentWrapper>
  );
};

export default NegativeFeedbackForm;
